// src/layouts/MainLayout.jsx
import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from '../../Components/SideBar';
import DashboardHeader from '../../Components/DashboardHeader';
import SimpleFooter from '../../Components/SimpleFooter';
import { UpgradeModalProvider } from '../../contexts/UpgradeModalContext';

export default function MainLayout() {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location=useLocation()

  const toggleSidebar = () => {
    // If small screen, toggle mobile drawer; else toggle collapsed width
    if (typeof window !== 'undefined' && window.innerWidth < 768) {
      setMobileOpen((prev) => !prev);
    } else {
      setCollapsed((prev) => !prev);
    }
  };
  // Close mobile drawer on route change
  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);
  const isChat=location?.pathname==="/Dashboard/Chat"
// console.log("location-----------",location)
  return (
    <UpgradeModalProvider>
      <div
        style={{
          background: isChat
            ? "#212C43"
            : "linear-gradient(135deg,rgba(18, 25, 46, 1) 30%, #2E428A 100%)",
        }}
        className="flex h-screen overflow-hidden"
      >
        <Sidebar
          collapsed={collapsed}
          mobileOpen={mobileOpen}
          onCloseMobile={() => setMobileOpen(false)}
        />
        <div className="flex min-w-0 flex-1 flex-col">
          {!isChat ? (
            <DashboardHeader onToggleSidebar={toggleSidebar} />
          ) : null}
          <div className="min-w-0 flex-1 overflow-x-hidden overflow-y-auto">
            <Outlet />
          </div>
        </div>
      </div>
    </UpgradeModalProvider>
  );
}
